/**
 * CSS class names applied to SVG product paths by the product
 * interaction layer (`useSvgProductInteraction`).
 *
 * Used in:
 * - `useSvgProductInteraction` — when wiring listeners and applying coloring
 * - `processTierSvg` — the injected CSS targets these class names (`path.interior`)
 * - `TiersView` SCSS — styles scoped to these classes
 * - `ModelView` (Hero) — outline paths (no `path.interior` class)
 *
 * Keep in sync with the CSS rules in `TiersView.module.scss`.
 *
 * Sentinel classes (INSOLATION_COLOR, COMPARE_COLOR, CATEGORY_COLOR) mark
 * which colorMode family is active so reset logic can strip the right bucket
 * classes without knowing the previous bucket value.
 */
export const SVG_PRODUCT_CLASS = {
  /** Sold and visible — single "sold" fill color */
  STATUS_SOLD:  'status-sold',
  /** Available — status color mode */
  STATUS_AVAILABLE: 'status-available',
  /** Reserved — status color mode */
  STATUS_RESERVED:  'status-reserved',
  /** Excluded by current filters — muted/invisible */
  FILTERED_OUT: 'filtered-out',
  /** Currently selected product */
  ACTIVE:       'active',
  ACTIVE_TAG:   'active-tag',
  /** Mobile tap preview — visually matches desktop :hover */
  PREVIEW:      'preview',

  // --- colorMode ---
  // ROOMS_COLOR is a single class — it is both the marker and the styling hook.
  // The *_COLOR classes below are paired with a dynamic bucket class (e.g. `insolation-5`,
  // `compare-p3`, `category-apartment_standard`). They serve as sentinels so reset logic
  // can locate and remove the bucket class without knowing the previous value.
  /** Colored by number of rooms */
  ROOMS_COLOR:  'rooms-color',
  /** Paired with a dynamic `insolation-{0..10|null}` bucket class */
  INSOLATION_COLOR: 'insolation-color',
  /** Paired with a dynamic `compare-{p0..p9}` bucket class */
  COMPARE_COLOR:    'compare-color',
  /** Paired with a dynamic `category-{key}` bucket class */
  CATEGORY_COLOR:   'category-color',
}
